import React from "react";
import BundlesWrap from "./BundlesWrap";

function Bundles(props) {
    return (
        <>
            <section className="bundles-bg section-bottom-pad"><BundlesWrap/></section>
        </>
    )
}

export default Bundles;
